import { createContext } from "react";

export const FeaturePageSourceIndexContext = createContext<ReadonlyMap<string, number>>(new Map());
